// Pinia works on Vue 2 if you've installed pinia@^2 and set it up in main.js
import { defineStore } from 'pinia';

const MIN = 25;
const MAX = 150;
const STEP = 25;

function applyZoomVars(levelPct) {
  const zoom = levelPct / 100;
  //const inv = 1 / zoom;
  const root = document.documentElement;
  root.style.setProperty('--zoom', String(zoom));
  root.style.setProperty('zoom', String(zoom));
  //root.style.setProperty('--app-zoom-inv', String(inv));
}

export const useZoomStore = defineStore('zoom', {
  state: () => ({
    level: 100,          // percentage, e.g., 100
    min: MIN,
    max: MAX,
    step: STEP,
    persist: true,       // set to false if you don't want localStorage
  }),
  getters: {
    canZoomIn: (s)  => s.level < s.max,
    canZoomOut: (s) => s.level > s.min,
    levelFloat: (s) => s.level / 100,
    // replicate your rowHeight logic
    rowHeight: (s) => {
      const multiplier = 1 - s.level / 100 + 1; // same formula you had
      return 360 * (multiplier * 1.35);
    },
    // if you still want style helpers:
    zoomInDisabledStyle: (s) =>
      s.level === s.max ? { '--cursor': 'not-allowed', '--color': '#ffffff80' }
                        : { '--cursor': 'pointer', '--color': 'white' },
    zoomOutDisabledStyle: (s) =>
      s.level === s.min ? { '--cursor': 'not-allowed', '--color': '#ffffff80' }
                        : { '--cursor': 'pointer', '--color': 'white' },
  },
  actions: {
    init() {
      if (this.persist) {
        const saved = parseInt(localStorage.getItem('app.zoomLevel'), 10);
        if (!Number.isNaN(saved) && saved >= this.min && saved <= this.max) {
          this.level = saved;
        }
      }
      applyZoomVars(this.level);
      // keep CSS vars & storage in sync with any future changes
      this.$subscribe((_mutation, state) => {
        applyZoomVars(state.level);
        if (state.persist) {
          localStorage.setItem('app.zoomLevel', String(state.level));
        }
      });
    },
    set(levelPct) {
      const clamped = Math.max(this.min, Math.min(this.max, Math.round(levelPct)));
      console.log(`set zoom`, clamped);
      this.level = clamped;
    },
    zoomIn() {
      if (this.canZoomIn) this.level = Math.min(this.max, this.level + this.step);
    },
    zoomOut() {
      if (this.canZoomOut) this.level = Math.max(this.min, this.level - this.step);
    },
    reset() {
      this.level = 100;
    },
  },
});
